import { useQuery } from 'data-fetching-client';
import { USER_INFO_QUERY } from '../queries/fetchUserInfo';
export const useFetchUserInfo = () => useQuery(USER_INFO_QUERY);